import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default props => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>SEND_MEDIA_SESSION_EVENTS</h1>
        </div>
        <p>
          Emit this socket event when the media session's state has changed.
          Eg.: the user has muted their microphone or disabled video.
        </p>
        <h2>Payload Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>JSON type</th>
              </tr>
              <tr>
                <td>category</td>
                <td>The type of media session event.</td>
                <td>string</td>
              </tr>
              <tr>
                <td>content</td>
                <td>
                  Current state of media session:
                  <ul>
                    <li>
                      <em>mediaSession: </em>(object) Current media session
                      state
                      <ul>
                        <li>
                          <em>audio: </em>(boolean) Is the user sending audio
                          enabled
                        </li>
                        <li>
                          <em>connected: </em>(boolean) Is the media session
                          connected
                        </li>

                        <li>
                          <em>isCollabOnly: </em>(boolean) corresponds to
                          whether the user is allowed to collaborate in the
                          space or not
                        </li>
                        <li>
                          <em>joinTime: </em>(string) Exact date when the user
                          has joined the space
                        </li>
                        <li>
                          <em>selfMuted: </em>(boolean) Is the user muted
                          locally
                        </li>
                        <li>
                          <em>video: </em>(boolean) Is the user sending video
                          enabled
                        </li>
                      </ul>
                    </li>
                    <li>
                      <em>streamId: </em>(string, optional) Unique identifier of
                      the local media feed
                    </li>
                    <li>
                      <em>subscribeTime: </em>(string) Date value describing
                      when the user has joined the space
                    </li>
                  </ul>
                </td>
                <td>Object</td>
              </tr>
              <tr>
                <td>comment</td>
                <td>Optional text description of socket event.</td>
                <td>string</td>
              </tr>
              <tr>
                <td>created</td>
                <td>Timestamp of when message item was created.</td>
                <td>string</td>
              </tr>
              <tr>
                <td>data</td>
                <td>
                  <b>DEFINITION UNCLEAR</b> is it substitute for
                  'video.screensharedata' response, should return an array of
                  objects with screenshare frames? Always returns an empty array
                </td>
                <td>array</td>
              </tr>
              <tr>
                <td>sender</td>
                <td>
                  Information about the sender
                  <ul>
                    <li>
                      <em>_id</em>: (string) User's id
                    </li>
                    <li>
                      <em>displayname</em>: (string) sender's name which is seen
                      by the other space participants
                    </li>
                    <li>
                      <em>phone_numbers</em>: (array of objects)
                    </li>

                    <ul>
                      <li>
                        <em>verified:</em> (boolean) defines whether the phone
                        number is verified
                      </li>
                      <li>
                        <em>primary:</em> (boolean) defines whether the phone
                        number is primary
                      </li>
                      <li>
                        <em>canonicalForm:</em> (string) phone number's standard
                        form
                      </li>
                      <li>
                        <em>type:</em> (string) default is 'mobile'
                      </li>
                      <li>
                        <em>value:</em>(string) phone number value
                      </li>
                    </ul>
                    <li>
                      <em>picture_url</em>: (string) a URL to user's profile
                      image
                    </li>
                    <li>
                      <em>type</em>: (string) type of sender ('user' or
                      'anonymous')
                    </li>
                    <li>
                      <em>username</em>: (string) Sender's login name
                    </li>
                  </ul>
                </td>
                <td>Object</td>
              </tr>
              <tr>
                <td>topicId</td>
                <td>
                  Unique identifier of the space the media session is part of.
                </td>
                <td>string</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3>Media Session Event Categories</h3>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
              </tr>
              <tr>
                <td>trackstatus</td>
                <td>
                  Change in state of media session (eg.: user muted/unmuted,
                  started screensharing). The first time trackstatus is
                  sent/received is treated as starting the call.
                </td>
              </tr>
              <tr>
                <td>video.end</td>
                <td>End audio/video call</td>
              </tr>
              <tr>
                <td>video.stopscreenshare</td>
                <td>Screen shared ended</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Authorization</h2>
        <p>Subscribed to channel.</p>
        <h2>Example</h2>
        <pre className="javascript">
          socketConnection.emit('SEND_MEDIA_SESSION_EVENTS', payload);
        </pre>
        <h4>Payload ('trackstatus')</h4>
        <pre className="json">
          {`{
    "category": "tracksstatus",
    "content": {
        "mediaSession": {
            "audio": true,
            "connected": true,
            "isCollabOnly": false,
            "joinTime": "2020-08-04T06:56:22.660Z",
            "selfMuted": false,
            "video": true
        },
        "streamId": "f50oyeFS29u2tDL1ntF2UgdgOpU4jNDCeEOk",
        "subscribeTime": "2020-08-04T06:55:37.461Z"
    },
    "created": "2020-08-04T06:56:22.659Z",
    "data": [
    ],
    "sender": {
        "_id": "5f04251caa4a347af9946e05",
        "displayname": "Test User",
        "phone_numbers": [
        ],
        "picture_url": "https://storage.googleapis.com/onesna/pictures/pfpic_ltest_34cb97bd-0151-449d-84b0-48e07853b49g",
        "type": "user",
        "username": "test@user.com"
    },
    "topicId": "5f06c25e574ca36b54cb4cdg"
}`}
        </pre>
        <h4>Payload ('video.end')</h4>
        <pre className="json">
          {`{
   "topicId":"5f06c25e574ca36b54cb4cdg",
   "category":"video.end",
   "comment":"toggle Video Session",
   "sender":{
      "_id":"5f04251caa4a347af9946e05",
      "type":"user",
      "username":"test@user.com",
      "displayname":"Test User",
      "picture_url":"https://storage.googleapis.com/onesna/pictures/pfpic_ltest_34cb97bd-0151-449d-84b0-48e07853b49g",
      "phone_numbers":[

      ]
   },
   "data":[

   ],
   "created":"2020-08-04T06:56:50.023Z",
   "content":{
      "subscribeTime":"2020-08-04T06:55:37.461Z",
      "mediaSession":{

      }
   }
}`}
        </pre>
        <h4>Payload ('video.stopscreenshare')</h4>
        <pre className="json">
          {`{
   "topicId":"5f06c25e574ca36b54db4cdf",
   "category":"video.stopscreenshare",
   "content":{
      "mediaSession":{
         "audio":true,
         "video":true,
         "connected":true,
         "screenshare":false,
         "isCollabOnly":false,
         "joinTime":"2020-08-04T06:59:47.262Z"
      },
      "subscribeTime":"2020-08-04T06:58:06.254Z"
   },
   "sender":{
      "_id":"5f04251caa4a347af9946e01",
      "type":"user",
      "username":"test@user.com",
      "displayname":"Test User",
      "picture_url":"https://storage.googleapis.com/onesna/pictures/pfpic_ltest_34cb97bd-0151-449d-84b0-48e07853b49f",
      "phone_numbers":[

      ]
   },
   "data":[

   ],
   "created":"2020-08-04T07:00:11.071Z"
}`}
        </pre>
      </div>
    </div>
  </Layout>
)
